var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownTriangleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 4,
    viewBox: "0 0 5 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.3998 3.59998L4.7998 -2.45571e-05H-0.000195503L2.3998 3.59998Z",
    fill: "#4D5874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownTriangleIcon);
export default __webpack_public_path__ + "static/media/down_triangle_icon.7c2a8bb7ef9864cb13e63aab4fd45b70.svg";
export { ForwardRef as ReactComponent };